/**
 * ServiceSettings管理用のカスタムフック
 * ServiceSettingsの取得とタイムスタンプ管理を共通化
 */

import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { serviceSettingsActions } from '../reducers/serviceSettings';

/**
 * ServiceSettingsの初期取得とタイムスタンプ管理を行うフック
 * 
 * @returns {Object} タイムスタンプ管理用のstate
 * @returns {number | null} lastProcessedTimestamp - 最後に処理した保存タイムスタンプ
 * @returns {Function} setLastProcessedTimestamp - タイムスタンプ更新関数
 */
export const useServiceSettings = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  
  // 最後に処理した保存タイムスタンプを記録
  const [lastProcessedTimestamp, setLastProcessedTimestamp] = useState<number | null>(null);

  // ServiceSettingsを取得
  useEffect(() => {
    dispatch(serviceSettingsActions.fetchServiceSettings());
  }, [dispatch]);

  return {
    lastProcessedTimestamp,
    setLastProcessedTimestamp,
  };
};